import React from "react";
import { projects } from "../constants";
import { github } from "../assets";

/* ═══════════════════════════════════════════════════════════
   WORKS — Luxury Project Grid
   Gold spotlight cards · liquid reveals · hover lift
   ═══════════════════════════════════════════════════════════ */

const ProjectCard = ({ name, description, tags, image, source_code_link, index }) => (
  <div
    className="lux-card reveal-fade group"
    data-parallax={0.03 + (index % 3) * 0.02}
  >
    {/* Image */}
    <div className="relative overflow-hidden aspect-[16/10]">
      <img
        src={image}
        alt={name}
        className="w-full h-full object-cover transition-transform duration-[1.2s] group-hover:scale-105"
        style={{ transitionTimingFunction: "var(--ease-luxury)" }}
        loading="lazy"
      />
      {/* Gold overlay on hover */}
      <div
        className="absolute inset-0 bg-gradient-to-t from-obsidian-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700"
        style={{ transitionTimingFunction: "var(--ease-luxury)" }}
      />
      {/* Source link */}
      <a
        href={source_code_link}
        target="_blank"
        rel="noreferrer"
        className="absolute top-4 right-4 w-10 h-10 rounded-full bg-obsidian-950/60 backdrop-blur-md border border-white/10 flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500"
        style={{ transitionTimingFunction: "var(--ease-luxury)" }}
        aria-label={`View ${name} source`}
      >
        <img src={github} alt="GitHub" className="w-4 h-4 object-contain" />
      </a>
    </div>

    {/* Content */}
    <div className="p-7">
      <h3 className="font-grotesk text-lg font-medium text-silver-100 mb-3">
        {name}
      </h3>
      <p className="lux-body text-sm">{description}</p>

      <div className="mt-5 flex flex-wrap gap-2">
        {tags.map((tag) => (
          <span
            key={`${name}-${tag.name}`}
            className="font-grotesk text-[0.65rem] tracking-[0.15em] uppercase text-champagne-400/80 border border-champagne-500/20 rounded-full px-3 py-1"
          >
            {tag.name}
          </span>
        ))}
      </div>
    </div>
  </div>
);

const Works = () => {
  return (
    <div className="lux-container">
      <div className="max-w-3xl mb-20">
        <p className="lux-eyebrow mb-6">My work</p>
        <h2 className="lux-heading">
          <span className="reveal-line">
            <span>Selected</span>
          </span>
          <span className="reveal-line">
            <span className="lux-gold">Projects</span>
          </span>
        </h2>
      </div>

      <p className="lux-body max-w-3xl mb-16 reveal-fade">
        Following projects showcase my skills and experience through
        real-world examples of my work. Each project is briefly described
        with links to code repositories and live demos. It reflects my
        ability to solve complex problems, work with different technologies,
        and manage projects effectively.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {projects.map((project, index) => (
          <ProjectCard key={`project-${index}`} {...project} index={index} />
        ))}
      </div>
    </div>
  );
};

export default Works;